<ion-content>
  <div class="gap-five flex flex-col">
    <div *ngIf="isDraft" class="gap-five flex flex-col">
      <button
        class="flex flex-row items-center gap-2.5"
        (click)="$event.stopPropagation(); emitAction('onLoadOrder', order)"
      >
        <ion-icon src="../../../assets/icon/cloud-upload.svg"></ion-icon>
        <span>Cargar pedido guardado</span>
      </button>

      <button
        class="flex flex-row items-center gap-2.5"
        (click)="emitAction('onOpenDetails', { order: order, id: order.id }); $event.stopPropagation()"
      >
        <ion-icon src="../../../assets/icon/eye.svg"></ion-icon>
        <span>Ver detalles</span>
      </button>

      <hr />

      <button
        class="remove-button flex flex-row items-center gap-2.5"
        (click)="emitAction('onDeleteDraft', order); $event.stopPropagation()"
      >
        <ion-icon src="../../../assets/icon/eliminar.svg"></ion-icon>
        <span>Eliminar pedido</span>
      </button>
    </div>

    <div *ngIf="!isDraft" class="gap-five flex flex-col">
      <!-- Modificar dirección de entrega -->
      <ng-container *ngIf="(isPaid || isRefunded) && alloworderDataModification">
        <div *ngIf="isPaid && !order.shippingAddress.pickupPointCode" class="gap-five flex flex-col">
          <button
            class="flex flex-row items-center gap-2.5"
            (click)="$event.stopPropagation(); emitAction('onModifyAddress', { order: order, addressType: 'shipping' })"
          >
            <ion-icon src="../../../assets/icon/camion.svg"></ion-icon>
            <span class="w-fit text-start">Modificar datos de envío</span>
          </button>
          <hr />
        </div>

        <!--<div *ngIf="isPaid" class="flex flex-col gap-five">-->
        <!--  <button class="flex flex-row items-center gap-2.5"-->
        <!--          (click)="$event.stopPropagation();emitAction('onModifyAddress', {order: order, addressType: 'billing'});">-->
        <!--    <ion-icon src="../../../assets/icon/accounting-invoice.svg"></ion-icon>-->
        <!--    <span class="w-fit text-start">Modificar datos de facturación</span>-->
        <!--  </button>-->

        <!--  <hr>-->
        <!--</div>-->
      </ng-container>

      <ng-container *ngIf="isPaid || isRefunded; else tryButton">
        <button
          class="flex flex-row items-center gap-2.5"
          (click)="emitAction('onOpenDetails', { order: order, id: order.id }); $event.stopPropagation()"
        >
          <ion-icon src="../../../assets/icon/paragraphs-bullets.svg"></ion-icon>
          <span>Detalles de tu pedido</span>
        </button>

        <button
          class="flex flex-row items-center gap-2.5"
          (click)="$event.stopPropagation(); emitAction('onDownloadInvoice', order)"
        >
          <ion-icon src="../../../assets/icon/download-icon.svg"></ion-icon>
          <span>Descargar factura</span>
        </button>

        <!-- Pago/Reembolsado: Compartir -->
        <button
          *ngIf="!order.blockSharing"
          class="flex flex-row items-center gap-2.5"
          (click)="$event.stopPropagation(); emitAction('onShare', order.id)"
        >
          <ion-icon src="../../../assets/icon/plane.svg"></ion-icon>
          <span>Compartir carrito</span>
        </button>
      </ng-container>

      <ng-template #tryButton>
        <button
          [routerLink]="['/cart']"
          [queryParams]="{ orderId: order.id }"
          class="flex flex-row items-center gap-2.5"
        >
          <ion-icon src="../../../assets/icon/retry-payment.svg"></ion-icon>
          <span>Reintentar pago</span>
        </button>
      </ng-template>

      <ng-container *ngIf="isPaid">
        <button
          class="flex flex-row items-center gap-2.5"
          (click)="$event.stopPropagation(); emitAction('onRepeatOrder', order)"
        >
          <ion-icon src="../../../assets/icon/repeat-order.svg"></ion-icon>
          <span>Repetir pedido</span>
        </button>
      </ng-container>

      <ng-container *ngIf="showReportIncident">
        <button
          [disabled]="order.hasReportIncident"
          [ngClass]="{ 'bg-gray-100': order.hasReportIncident }"
          class="flex flex-row items-center gap-2.5"
          (click)="$event.stopPropagation(); emitAction('onReportIncidentOrder', order)"
        >
          <ion-icon src="../../../assets/icon/incidencia.svg"></ion-icon>
          <span>{{ !hasReportIncident ? 'Notificar una incidencia' : 'Incidencia notificada' }}</span>
        </button>
      </ng-container>

      <ng-container *ngIf="isPaid && isProcessPending && !pendingRestartedOrderExists && !hasSomeRefund">
        <button
          class="flex flex-row items-center gap-2.5"
          (click)="$event.stopPropagation(); emitAction('onRestartOrder', order)"
        >
          <ion-icon class="color-cyan" src="../../../assets/icon/pencil.svg"></ion-icon>
          <span class="color-cyan">Rehacer pedido</span>
        </button>
      </ng-container>
    </div>
  </div>
</ion-content>
